import { render, staticRenderFns } from "./LegalDocumentsActivity.vue?vue&type=template&id=0de3159c&scoped=true&"
import script from "./LegalDocumentsActivity.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentsActivity.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentsActivity.vue?vue&type=style&index=0&id=0de3159c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de3159c",
  null
  
)

export default component.exports